import React from "react";
import { FormattedMessage } from "react-intl";
import { H2, P1 } from "../../styles";
import Icon from "../../../icons";

import messages from "./messages";
import { StyledIcon, Container } from "./styles";
import { IProps } from "./interfaces";
import FormattedHtmlMessage from "../../../../common/helpers/FormattedHtmlMessage";

const Hello = ({ noTitle }: IProps) => (
    <Container>
        {!noTitle && (
            <H2>
                <StyledIcon>
                    <Icon.rhytName active />
                    <br />
                </StyledIcon>
                <FormattedMessage {...messages.title} />
            </H2>
        )}
        <P1 center>
            <FormattedHtmlMessage {...messages.description} />
        </P1>
    </Container>
);

export default Hello;
